module.exports = __webpack_public_path__ + "img/p4.2e4fdde5.png";